import { gsap } from "gsap";

export function loading() {
    // =========================
// ローディングアニメーション
// =========================

// document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", function(){
  const loaderBlue = document.querySelector(".l-loading.cls-blue");
  const loaderBlend = document.querySelector(".l-loading.cls-blend");
  const svgBlue = loaderBlue.querySelector(".loader-svg");
  const svgBlend = loaderBlend.querySelector(".loader-svg");

  // スクロール禁止
  gsap.set("body", { overflow: "hidden" });

  const tl = gsap.timeline({
    defaults: { ease: "power2.out" }
  });

  // 1）背景のみ → 少し待機
  tl.to({}, { duration: 0.2 });

  // 2）青SVGフェードイン
  tl.fromTo(
    svgBlue,
    // { opacity: 0, scale: 0.8 },
    // { opacity: 1, scale: 1, duration: 0.8 }
    { opacity: 0 },
    { opacity: 1, duration: 0.3 }
  );

  // 3）青レイヤーをフェードアウト（白背景も消える）
  tl.to(loaderBlue, {
    opacity: 0,
    delay: 0.6,
    duration: 0.4
  });

  // 4）黒SVG（blend）が巨大化しながら“くぐる”
  tl.fromTo(
    svgBlend,
    { scale: 1, opacity: 1, filter: "blur(0px)" },
    {
      scale: 60, // 画面外へ吹き飛ぶ値
      opacity: 1,
      duration: 1.4,
      ease: "power3.inOut"
    }
  );

  // 5）ラストで blur + フェードアウト
  tl.to(
    svgBlend,
    {
      opacity: 0,
      filter: "blur(20px)",
      duration: 0.4,
      ease: "power2.in"
    },
    "-=0.6" // 巨大化の終盤から重ねて開始
  );

  // ローディング完了 → レイヤー自体を消す
  tl.to([loaderBlue, loaderBlend], {
    display: "none",
    duration: 0
  });

  // スクロール解除
  tl.to("body", { overflow: "auto", duration: 0 });

});


}